import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class ServicoAtendimentoApiClient {

    async buscarTodos(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/servico-atendimento',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async cadastrar(dados) {
        return axios.post('/servico-atendimento/inserir/', dados)
    }

    async editar(dados) {
        return axios.put('/servico-atendimento/atualizar/', dados)
    }

    async excluir(dados) {
        return axios.delete(`/servico-atendimento/deletar/${dados.atendimentoId}/${dados.servicoId}`)
    }


}

export default new ServicoAtendimentoApiClient()